import { cva } from '@/styled-system/css';

export const bannerRecipe = cva({
  base: {
    'display': 'flex',
    'justifyContent': 'center',
    'paddingBlock': 'default',
    'paddingInline': 'default',
    'textStyle': 'body',
    'borderRadius': 'obj.fullWidth',
    'gap': 'default',
    '&:has([data-c11n-component="Banner.Close"]) > [data-c11n-component="Banner.Body"]': {
      flex: 'auto',
    },
  },
  variants: {
    tone: {
      critical: {
        backgroundColor: 'Banner.critical.bg',
        color: 'text.onImpact.neutral',
      },
      info: {
        backgroundColor: 'Banner.info.bg',
        color: 'text.onImpact.neutral',
      },
      success: {
        backgroundColor: 'Banner.success.bg',
        color: 'text.onImpact.neutral',
      },
      warning: {
        backgroundColor: 'Banner.warning.bg',
        color: 'text.onImpact.neutral',
      },
    },
  },
});
